import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import { postScheduleText } from 'Const/schedule';
import { PostChangeHostText } from 'Const/schedule-change-host/domain';
import postChangeHostBulk from 'Api/schedule-change-host/postChangeHostBulk';

import postChangeHostBulkRequest from './model/request/postChangeHostBulkRequest';
import { useNavigate } from 'react-router-dom';

const usePostChangeHostBulk = ({ filterState }) => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({ data }) => {
      onShowLoader({ variant: 'loader-primary' });

      const payload = postChangeHostBulkRequest(data);

      return await postChangeHostBulk({ payload });
    },
    onSuccess: () => {
      onOpenToast({
        status: 'success',
        description: PostChangeHostText.successDescription,
        duration: 5,
        alwaysShow: false,
      });
      queryClient.invalidateQueries({ queryKey: ['schedules', filterState] });
      navigate('/schedule/calendar');
    },
    onError: (error) => {
      const { response } = error;

      onOpenToast({
        status: 'error',
        description: response.data?.data?.message || postScheduleText.failedServerDescription,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePostChangeHostBulk;
